// @@TODO: import crypto from 'crypto'
const generateNonce = () => {
  // NOTE: A nonce should be at least 8 characters long, per Lighthouse advisory.
  // NOTE: For debugging, use a valid constant nonce.
  const nonce = Buffer.from('RaNdOmRaNdOm').toString('base64')
  //const nonce = crypto.randomBytes(16).toString('base64')
  return nonce
}

export default generateNonce
